/**
 * CopyIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CopyIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M9 17h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m0-2V5h10v10z"
      clipRule="evenodd"
    />
    <path d="M15 21a2 2 0 0 0 2-2H5V7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const CopyIcon = makeIcon('CopyIcon', CopyIconSvg)
